<template>
  <div class="order-list">
    <el-card class="query-card">
      <el-form :model="HistoryTraderRecordReqVo" ref="queryForm" label-width="auto" size="small" inline>

        <div class="query-grid">


            <el-form-item
                :label="$t('initUnTradeRecordPage.timetype2')"
                prop="time"
                class="full-row"
            >
              <el-select
                  v-model="HistoryTraderRecordReqVo.time"


                  filterable
                  style="width: 500px;"
              >
                <el-option
                    v-for="item in timeList"
                    :key="item.domianName"
                    :label="item.displayName"
                    :value="item.domianName"
                />
              </el-select>
            </el-form-item>






            <el-form-item :label="$t('initTestTradePage.startDate')" prop="startDate">
              <el-date-picker
                  style="width:210px"
                  v-model="HistoryTraderRecordReqVo.startDate"
                  type="datetime"

                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm:ss"
                  :clearable="false"
                  :editable="false"
              />
            </el-form-item>



            <el-form-item :label="$t('initTestTradePage.endDate')" prop="endDate">
              <el-date-picker
                  style="width:210px"
                  v-model="HistoryTraderRecordReqVo.endDate"
                  type="datetime"

                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm:ss"
                  :clearable="false"
                  :editable="false"
              />
            </el-form-item>


            <el-form-item :label="$t('initTestTradePage.randomOrderno')" prop="trNos">
              <div class="input-with-more">
                <el-input v-model="HistoryTraderRecordReqVo.trNos"  clearable />
                <!--                <el-button type="text" @click="openMoreDialog('trNos')">More</el-button>-->
              </div>
            </el-form-item>




          <!--支付状态-->

            <el-form-item
                :label="$t('initTestTradePage.paymentState')"
                prop="trStatus"
            >
              <el-select
                  v-model="HistoryTraderRecordReqVo.trStatus"

                  clearable
                  filterable
                  style="width: 100%;"
              >
                <el-option
                    :label="$t('initTradeRecordPage.noConfirm')"
                    value="-2"
                />
                <el-option
                    :label="$t('initTradeRecordPage.noProcess')"
                    value="-1"
                />
                <el-option
                    :label="$t('initTradeRecordPage.fail')"
                    value="0"
                />
                <el-option
                    :label="$t('initTradeRecordPage.success')"
                    value="1"
                />
              </el-select>
            </el-form-item>





            <el-form-item :label="$t('initTestTradePage.businessOrderno')" prop="trMerOrderno">
              <div class="input-with-more">
                <el-input v-model="HistoryTraderRecordReqVo.trMerOrderno" clearable />
              </div>
            </el-form-item>



          <!--网关交易号-->

            <el-form-item
                :label="$t('initUnTradeRecordPage.gatewayNo')"
                prop="trGwNo"
            >
              <el-select
                  v-model="HistoryTraderRecordReqVo.trGwNo"

                  clearable
                  filterable
                  style="width: 100%;"
              >
                <el-option
                    v-for="item in gatewayList"
                    :key="item.gwNo"
                    :label="item.gwNo1"
                    :value="item.gwNo"
                />
              </el-select>
            </el-form-item>






<!--          <el-form-item class="btn-row" label-width="0">
            <el-button type="primary" @click="handleSearch">{{ $t('query') }}</el-button>
            <el-button @click="handleReset">{{ $t('reset') }}</el-button>
          </el-form-item>-->

        </div>
        <div class="btn-row">
          <el-button type="primary" @click="handleSearch">{{ $t('query') }}</el-button>

          <el-button @click="handleReset">{{ $t('reset') }}</el-button>
        </div>

        <!-- 通用 More 弹窗（只保留一个）  :title="getDialogTitle" -->
        <el-dialog
            :visible.sync="moreDialogVisible"
            width="800px"
            @close="onMoreDialogClose"
        >
          <el-input
              type="textarea"
              :rows="8"
              v-model="moreInput"
              :placeholder="`请输入多个值,请使用英文逗号隔开，做到输入1000个值。例如：\nVALUE1\nVALUE2, VALUE3`"
          />
          <span slot="footer">
    <el-button @click="closeMoreDialog">取消</el-button>
    <el-button type="primary" @click="confirmMoreInput">确定</el-button>
  </span>
        </el-dialog>
      </el-form>

    </el-card>

    <div class="action-toolbar">




    </div>


    <el-card class="table-card" style="margin-top: 16px; overflow-x: auto;">
      <el-table :data="tableData" border style="width: 100%" v-loading="loading" show-overflow-tooltip
                :cell-style="{whiteSpace: 'nowrap'}"
                :header-cell-style="{whiteSpace: 'nowrap'}"
      >

<!--        <el-table-column

            width="120" align="center" :label="$t('choose')">
          <template slot-scope="scope">
            <el-radio
                v-model="selectedRowId"
                :label="scope.row.trNo"
                @change="handleRadioChange(scope.row)"
            >
              {{''}}
            </el-radio>
          </template>
        </el-table-column>-->

        <el-table-column prop="gwNoName" :label="$t('initTestTradePage.gatewayNo')" :min-width="columnWidths.gatewayNo"></el-table-column>
        <el-table-column prop="ttrNo" :label="$t('initTestTradePage.randomOrderno')" :min-width="columnWidths.randomOrderno" width="210"></el-table-column>
        <el-table-column prop="ttrMerOrderno" :label="$t('initTestTradePage.businessOrderno')" :min-width="columnWidths.businessOrderno"  width="210"></el-table-column>

        <el-table-column  :label="$t('initTestTradePage.tradeMoney')" :min-width="columnWidths.tradeMoney">
          <template #default="scope">
            <span>{{ scope.row.ttrCurrency }} {{ formatMoney(scope.row.ttrAmount) }}</span>
          </template>
        </el-table-column>



        <el-table-column :label="$t('initTestTradePage.guaranteeMoneyDeductRate')" :min-width="columnWidths.guaranteeMoneyDeductRate">
          <template #default="scope">
            <span>{{ scope.row.ttrCurrency }} {{ formatMoney(scope.row.ttrMrReseverRate) }} %</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('initTestTradePage.paymentState')" :min-width="columnWidths.paymentState">
          <template slot-scope="scope">

              <span v-if="scope.row.ttrStatus === -2">{{$t('initTradeRecordPage.tradeState1')}}</span>

              <span v-else-if="scope.row.ttrStatus === -1">{{$t('initTradeRecordPage.tradeState2')}}</span>

              <span v-else-if="scope.row.ttrStatus === 0" style="color: red;">{{$t('initTradeRecordPage.tradeState3')}}</span>

              <span v-else-if="scope.row.ttrStatus === 1">{{$t('initTradeRecordPage.tradeState4')}}</span>


          </template>
        </el-table-column>
        <el-table-column prop="ttrWebsite" :label="$t('initTestTradePage.website')" :min-width="columnWidths.website"></el-table-column>
        <el-table-column prop="ttrReturnurl" :label="$t('initTestTradePage.returnurl')" :min-width="columnWidths.returnurl"></el-table-column>
        <el-table-column prop="tradeDatetime" :label="$t('initTestTradePage.tradeTime')" :min-width="columnWidths.tradeTime" width="250"></el-table-column>
        <el-table-column prop="ttrBankcode" :label="$t('initTestTradePage.wrongcode')" :min-width="columnWidths.wrongcode"></el-table-column>
        <el-table-column prop="ttrBankinfoOut" :label="$t('initTestTradePage.wronginfo')" :min-width="columnWidths.wronginfo"></el-table-column>



      </el-table>

      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 50]"
          :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          style="margin-top: 16px; text-align: right;"
      />
    </el-card>




  </div>
</template>

<script>
import { hasPermission } from "@/utils/permission";
export default {
  name: "OrderList",
  data() {
    return {

      commonLabelStyle: {
        width: '180px',
        minWidth: '150px',
        textAlign: 'center',  // 文字居中
        wordBreak: 'break-all'
      },
      // 内容区也居中
      commonContentStyle: {
        textAlign: 'center'
      },
      HistoryTraderRecordReqVo: {
        time: 'GMT+08:00',
        trNos:"",
        trMerOrderno:"",
        dateType:"",
        trStatus:"",
        startDate:"",
        endDate:"",
        upIsExp:"",
        upExpType:"",
        upExpStatus:"",
        trGwNo:"",
      },

      moreDialogVisible: false,
      moreInput: '',          // 弹窗中的文本内容
      currentField: null,     // 当前正在编辑的字段名，
      hasSearched: false,   //  是否有进行查询
      timeList: [],
      gatewayList: [],
      tableData: [],
      columnWidths:{},
      pagination: {
        page: 1,
        size: 10,
        total: 0,
      },
    };
  },
  created() {
    // this.handleSearch(); // 初始化加载数据
    // 组件创建后设置默认时间
    this.setDefaultTime(); //时间设置
    this.getTimeOptions();
    // 网关号
    this.getGatewayOptions();
  },
  mounted() {
    this.$nextTick(() => {
      this.initColumnWidths();
    });
  },
  watch:{
    '$i18n.locale'(newVal, oldVal) {
      this.getTimeOptions();
    }
  },
  methods: {
    // 金额格式化：千分位 + 强制保留两位小数
    formatMoney(value) {
      if (!value) return "0.00";

      // 使用原生的 toLocaleString 方法实现 #,##0.00 的效果
      return Number(value).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    // 时区
    async getTimeOptions() {
      try {
        this.timeList=[]
        const res = await this.$axios.get('/api/unnormal/traderecord/getTime');
        if (res.data.code === 0) {

          this.timeList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
          this.timeList = [];
        }

      } catch (error) {
        console.error('获取网关下拉列表失败:', error);
      }
    },
    // 网关号
    async getGatewayOptions() {
      try {

        const res = await this.$axios.get('/api/gateway/getlist');
        if (res.data.code === 0) {

          this.gatewayList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
          this.gatewayList = [];
        }



      } catch (error) {
        console.error('获取网关下拉列表失败:', error);
      }
    },
    hasPermission,
    //时间格式
    formatTime(isoTime) {
      if (!isoTime) return '-';

      try {
        const date = new Date(isoTime);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } catch (error) {
        return isoTime; // 如果解析失败，返回原值
      }},

    setDefaultTime() {
      // 只有在当前时间为空时才设置默认值
      if (!this.HistoryTraderRecordReqVo.startDate) {
        this.HistoryTraderRecordReqVo.startDate = this.getDefaultStartTime();
      }
      if (!this.HistoryTraderRecordReqVo.endDate) {
        this.HistoryTraderRecordReqVo.endDate = this.getCurrentTime();
      }
    },
    // 获取当前时间字符串，格式：YYYY-MM-DD HH:mm:ss
    getCurrentTime() {
      // return this.formatDateTime(new Date());
      const now = new Date();
      // 设置为当天 23:59:59
      now.setHours(23, 59, 59, 999); // 时, 分, 秒, 毫秒
      return this.formatDateTime(now);
    },
    // 获取当前时间往前推 1 年
    getDefaultStartTime() {
      // return this.formatDateTime(new Date());
      const now = new Date();
      // 设置为当天 23:59:59
      now.setHours(0, 0, 0, 0); // 时, 分, 秒, 毫秒
      return this.formatDateTime(now);
    },
    // 格式化日期为 'YYYY-MM-DD HH:mm:ss'
    formatDateTime(date) {
      const pad = (num) => String(num).padStart(2, '0');
      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
      const seconds = pad(date.getSeconds());
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 查询
    handleSearch() {
      this.pagination.page = 1; // 重置页码
      this.fetchOrderList();
    },
    // 重置
    handleReset() {
      this.$refs.queryForm.resetFields();

      this.hasSearched = false;
      //this.handleSearch();
    },


    // 分页：每页条数变化
    handleSizeChange(val) {
      /*  this.pagination.size = val;
        this.filterData();*/
      this.pagination.size = val;
      this.pagination.page = 1; //
      this.fetchOrderList(); //
    },
    // 分页：当前页变化
    handleCurrentChange(val) {
      /* this.pagination.page = val;
       this.filterData();*/

      this.pagination.page = val;
      this.fetchOrderList(); //
    },
    // 数据绑定
    handleRadioChange(row) {
      this.currentRow = row;
      this.selectedRowId = row.trNo;
    },
    // 查询
    async fetchOrderList() {
      this.loading = true;
      try {
        const params = {
          trNos : this.HistoryTraderRecordReqVo.trNos || undefined,
          time : this.HistoryTraderRecordReqVo.time || undefined,
          startDate : this.HistoryTraderRecordReqVo.startDate || undefined,
          endDate : this.HistoryTraderRecordReqVo.endDate || undefined,
          trStatus : this.HistoryTraderRecordReqVo.trStatus || undefined,
          trMerOrderno : this.HistoryTraderRecordReqVo.trMerOrderno || undefined,
          trGwNo : this.HistoryTraderRecordReqVo.trGwNo || undefined,


          page: this.pagination.page,
          limit: this.pagination.limit,
        };

        const res = await this.$axios.post('/api/Informal/TradeRecord',  params );

        if (res.data.code === 0) {

          this.currentRow = "";
          this.selectedRowId = "";

          const responseData = res.data.data;


          this.tableData = responseData.records || [];

          this.pagination.total = Number(responseData.total) || 0;
          this.pagination.page = Number(responseData.current) || this.pagination.page;
          this.pagination.limit = Number(responseData.size) || this.pagination.limit;

          if (this.pagination.total > 0) {
            this.hasSearched = true;
          }
        } else {
          this.$message.error(res.data.msg);
          this.tableData = [];
          this.pagination.total = 0;
        }
      } catch (err) {
        console.error('查询订单失败:', err);
        this.$message.error(this.$t('requestFailed'));
        this.tableData = [];
        this.pagination.total = 0;
      } finally {
        this.loading = false;
      }
    },


    // 通用打开弹窗方法
    openMoreDialog(fieldName) {
      this.currentField = fieldName;
      const currentValue = this.HistoryTraderRecordReqVo[fieldName] || '';
      // 直接显示原始内容（可能含逗号、空格等）
      this.moreInput = currentValue;
      this.moreDialogVisible = true;
    },

    /* confirmMoreInput() {
       this.queryParams[this.currentField] = this.moreInput; // ✅ 完全原样保存
       this.closeMoreDialog();
     },*/
    confirmMoreInput() {
      // 只需要去掉 # 前后的空格，保留值内部的其他空格
      const cleanedValue = this.moreInput
          .split(',')
          .map(item => item.trim())  // 去掉每个值的前后空格
          .filter(item => item.length > 0)  // 过滤空值
          .join(',');  // 用 # 重新连接

      this.HistoryTraderRecordReqVo[this.currentField] = cleanedValue;
      this.closeMoreDialog();

      this.$message.success(`已设置 ${cleanedValue.split('#').length} 个值`);
    },

    closeMoreDialog() {
      this.moreDialogVisible = false;
      this.currentField = null;
      this.moreInput = '';
    },

    onMoreDialogClose() {
      this.closeMoreDialog();
    },
    // 表头宽度
    initColumnWidths() {
      const cols = [
        "businessOrderno",
        'randomOrderno',
        'startDate',
        'endDate',
        'gatewayNo',
        'tradeMoney',
        'guaranteeMoneyDeductRate',
        'paymentState',
        'website',
        'returnurl',
        'tradeTime',
        'wrongcode',
        'wronginfo',

      ];
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      ctx.font = '14px Helvetica';

      cols.forEach(key => {
        const label = this.$t(
            `initTestTradePage.${key}`
        );

        this.$set(
            this.columnWidths,
            key,
            Math.ceil(ctx.measureText(label).width) + 50
        );
      });
    }
  },
};
</script>

<style>
/* 全局样式 - 表头居中 */
.el-table th .cell {
  white-space: nowrap !important;
  text-align: center !important;
}

.el-table .cell {
  white-space: nowrap !important;
  text-align: center !important;
}
</style>

<style scoped>
.order-list {
  padding: 20px;
}
/* 确保输入框、下拉框、时间选择器在栅格中占满 100% 宽度 */
.full-width {
  width: 100% !important;
}

/* 使用 Flex 布局优雅处理 输入框 + More 按钮 的组合 */
.input-with-more {
  display: flex;
  align-items: center;
  width: 100%;
}

.input-with-more .el-input {
  flex: 1; /* 让输入框自动撑满剩余空间 */
}

.input-with-more .el-button {
  margin-left: 10px; /* 按钮和输入框之间的间距 */
  flex-shrink: 0; /* 防止按钮被挤压变形 */
}
/* 防止日期行变形 用flex */
.el-form--inline .el-form-item {
  display: flex !important;
  align-items: center; /* 垂直居中 */
}
.el-form--inline .el-form-item {
  margin-right: 0 !important;
}

/* 保持表格原有样式不变 */
.table-card ::v-deep .el-table .cell {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.table-card ::v-deep .el-table th .cell {
  white-space: nowrap !important;
}
.table-card {
  overflow-x: auto;
}
.table-card ::v-deep .el-table {
  min-width: 100%;
}
/* 防止标签文字在空间被压缩时换行，保持表单高度一致 */
.query-card ::v-deep .el-form-item__label {
  white-space: nowrap;
}

/* 操作工具栏样式 */
.action-toolbar {
  margin-top: 16px;     /* 与上方查询卡片拉开间距 */
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* 按钮之间的间距调整 */
.action-toolbar .el-button {
  margin-left: 10px;
  margin-right: 0;
}

/*中间层样式*/
.summary-container {
  margin: 15px 0;
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.summary-card {
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  padding: 12px 15px;
  margin-bottom: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.card-label {
  font-size: 13px;
  color: #909399;
  margin-bottom: 6px;
  font-weight: bold;
}

.card-value {
  font-size: 18px;
  color: #303133;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

/* 人民币特殊复合布局 */
.sub-value {
  font-size: 14px;
  margin-left: 5px;
}

/* 颜色还原原项目的红绿状态 */
.text-success {
  color: #67C23A; /* ElementUI 经典的绿色 */
  font-weight: bold;
}

.text-danger {
  color: #F56C6C; /* ElementUI 经典的红色 */
  font-weight: bold;
}

/* --- 修改 1：美化查询表单的标签字体 --- */
.query-card /deep/ .el-form-item__label {
  white-space: nowrap !important;
  font-weight: 600 !important; /* 强制加粗生效 */
  color: #303133 !important; /* 强制颜色深灰生效 */
  font-size: 14px !important;
  letter-spacing: 0.5px !important;
  min-width: 140px;
  text-align: right;
}

/* --- 修改 2：美化输入框内的字体和边框 --- */
.query-card /deep/ .el-input__inner {
  font-weight: 500 !important; /* 强制生效 */
  color: #606266 !important; /* 强制生效 */
  border-radius: 6px !important; /* 强制微圆角生效 */
}

/*详细数据样式*/
/*::v-deep .section-divider {
  background-color: #f5f7fa !important; !* 跟表头的浅灰色背景一致 *!
  border-top: 2px solid #e4e7ed !important; !* 加粗一点上边框作为分割 *!
  text-align: left !important; !* 标题靠左对齐更好看 *!
  padding-left: 20px !important;
}*/


::v-deep .el-descriptions__body table tr:has(.section-divider){
  display:flex;
  width:100%;
}
::v-deep .el-descriptions__body table tr:has(.section-divider) th.section-divider{
  flex:1;
  display:flex;
  justify-content:center;
  align-items:center;

  background:#f5f7fa;
  padding:14px 0;

  border-top:2px solid #ebeef5;
}
::v-deep .el-descriptions__body table tr:has(.section-divider) td.section-divider{
  display:none;
}

::v-deep .section-title-row .el-descriptions-item__content{
  text-align:center;
  font-size:16px;
  font-weight:bold;
  background:#f5f7fa;
  color:#F56C6C;

  padding:6px 0 !important;
  line-height:15px;
}

.query-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  /*column-gap: 80px;*/
  column-gap: clamp(24px, 5vw, 80px);
  row-gap: 0;
  width: 100%;
}

.query-card ::v-deep .el-form-item.btn-row {
  display: flex !important;
  justify-content: center !important;
  margin-right: 0 !important; /* 抵消 inline 表单的右边距 */
}
/* 让 grid 子项独占一整行 */
.query-grid > .full-row {
  grid-column: 1 / -1; /* 从第1列到最后一列 */
}

/* 按钮独占一行 */
.btn-row {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-row .el-button + .el-button {
  margin-left: 10px;
}

/* 按钮 */
.btn-row .el-button {
  font-weight: 700;
  font-size: 14px;
  padding: 10px 24px;
  border-radius: 6px;
  min-width: 80px;
}

.section-title{
  font-size:18px;
  font-weight:600;
  text-align:center;
  margin:25px 0 15px;
  color:#303133;
}

.risk-title{
  color:#F56C6C;
}
</style>



// WEBPACK FOOTER //
// src/view/merTradeMgr/initTestTradePage.vue